import type {
  CartOption,
  CartProduct,
  CartShop,
} from '../_components/CartShopGroup';

// ── Helpers ──

/** 옵션 고유 키 (INDEPENDENT: productOptionItemIds 기반, COMBINATION: cartItemOptionId 기반) */
export const optionKey = (o: CartOption) =>
  o.productOptionItemIds.length > 0
    ? o.productOptionItemIds.toSorted().join('|')
    : o.cartItemOptionId;

/** 품절 옵션이 하나라도 있으면 품절 상품으로 취급 */
export const isProductSoldOut = (product: CartProduct) =>
  product.soldOutYN || product.options.some((o) => o.soldOutYN);

/** display 기준 체크 여부 (품절 상품은 unchecked) */
export const isProductEffectivelyChecked = (product: CartProduct) =>
  product.checked && !isProductSoldOut(product);

export const calcShopTotal = (shop: CartShop) =>
  shop.products.reduce(
    (sum, product) =>
      !isProductEffectivelyChecked(product)
        ? sum
        : sum +
          product.options.reduce(
            (s, o) => s + (o.soldOutYN ? 0 : o.price * o.quantity),
            0,
          ),
    0,
  );

export const calcShopDeliveryFee = (shop: CartShop) => {
  const checkedProducts = shop.products.filter(isProductEffectivelyChecked);
  if (checkedProducts.length === 0) return 0;

  const shopTotal = calcShopTotal(shop);

  // 무료배송 가능 상품이 있고 기준 금액 이상이면 배송비 0
  const hasFreeShipping = checkedProducts.some(
    (p) => p.freeShippingAvailable && shopTotal >= p.freeShippingAmount,
  );
  if (hasFreeShipping) return 0;

  // 체크된 상품 중 가장 높은 배송비 적용 (업체 단위 배송)
  return Math.max(...checkedProducts.map((p) => p.deliveryFee));
};

export const calcShopDiscount = () => 0;

export const calcShopCheckedCount = (shop: CartShop) =>
  shop.products.filter((p) => isProductEffectivelyChecked(p)).length;

export const calcCheckedCount = (shops: CartShop[]) =>
  shops.reduce((sum, shop) => sum + calcShopCheckedCount(shop), 0);
